import { render } from "./ReviewDetails.vue?vue&type=template&id=15110b00"
import script from "./ReviewDetails.vue?vue&type=script&lang=js"
export * from "./ReviewDetails.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__